import { Footer } from '@/scopes/common/components'
import { SummerContent } from '@/scopes/common/components/Footer/SummerContent'
import { Header } from '@/scopes/common/components/Header'
import { mqMin, tok, tokPx } from '@sunwebgroup/ui-components'
import { Breadcrumbs, Typography } from '@sunwebgroup/ui-components/uds'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'
import { MarketingPreferencesForm } from './components/MarketingPreferencesForm'

const queryClient = new QueryClient()

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const ContentWrapper = styled.div`
  background-color: ${tok('semantics_views_tinted_background_color')};
  flex-grow: 1;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: 0 ${tokPx('primitives_space_32')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: 0 ${tokPx('primitives_space_48')};
  }
`

const Title = styled(Typography)`
  ${Typography.modVariant('display-g-regular')};
  margin-right: auto;
  padding-left: ${tokPx('primitives_space_16')};
  margin: ${tokPx('primitives_space_16')} 0;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    ${Typography.modVariant('display-f-regular')};
    padding-left: 0;
    margin: ${tokPx('primitives_space_24')} 0;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    ${Typography.modVariant('display-e-regular')};
    margin-bottom: ${tokPx('primitives_space_32')};
  }
`

const Content = styled.div`
  max-width: ${tokPx('primitives_area_size_1440')};
  margin: 0 auto;
  color: ${tok('semantics_content_color')};

  padding-top: ${tokPx('primitives_space_16')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding-top: ${tokPx('primitives_space_24')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding-top: ${tokPx('primitives_space_32')};
  }
`

export function MarketingPreferences() {
  const intl = useIntl()

  return (
    <QueryClientProvider client={queryClient}>
      <Wrapper>
        <Header />
        <ContentWrapper>
          <Content>
            <Breadcrumbs
              items={[
                { id: 'home', label: intl.formatMessage({ id: 'breadcrumb_home' }), href: '/' },
                { id: 'holiday', label: intl.formatMessage({ id: 'breadcrumb_holiday' }), href: '/vakantie' },
                { id: 'marketing-preferences', label: intl.formatMessage({ id: 'breadcrumb_marketing_preferences' }) },
              ]}
            />
            <Title as="h1">{intl.formatMessage({ id: 'marketing_preferences_title' })}</Title>
            <MarketingPreferencesForm />
          </Content>
        </ContentWrapper>
        <Footer>
          <SummerContent />
        </Footer>
      </Wrapper>
    </QueryClientProvider>
  )
}
